import React from 'react'
import moment from 'moment'
import '../Styles/event.css'

import {
  Timeline, Checkbox, CheckboxGroup, Loader, Icon, IconButton, Modal, Button,
  ButtonToolbar, FormControl, ControlLabel, FormGroup
} from 'rsuite'
import { PaginateFilter, OpenBin, DeleteIcon } from '../Icons'

import defaultBackground from '../Styles/images/card-background-default.png'
import { colors, fonts } from '../Styles/common-styles'
import {
  Title, FlexWrapper, InlineFlex, SpanText, P, TimelineImage, Image,
  AddActivity, SmallTitle, Card, PinkSpan, NormalText, Back
} from './MyEventStyledComponents'

const styles = {
  buttonStyle: {
    borderColor: colors.grey,
    color: colors.grey,
    '&:hover': {
      background: '#efefef'
    }
  }
}

export const GoalsBlock = ({ title, goals, handleGoalSelect }) => {
  <>
    <Title>{title}</Title>
    <CheckboxGroup>
      {goals.map((goal, index) =>
        <Checkbox
          onChange={(value, checked) => handleGoalSelect(goal, checked)}
          key={index}>
          {goal}
        </Checkbox>)}
    </CheckboxGroup>
  </>
}

export const TimelinePhase = ({ phase, index, setActivityPreviewModal, setSelectedPhaseIndex, setActivityId }) => {
  return (
    <>
      <Timeline.Item key={index} dot={<Icon className='customDot' icon='' />}>
        <FlexWrapper>
          <InlineFlex style={{ justifyContent: 'flex-start' }}>
            <SmallTitle bolded>Phase: {index + 1} </SmallTitle>
            <SmallTitle>{phase.name}</SmallTitle>
          </InlineFlex>
        </FlexWrapper>
        <FlexWrapper>
          <InlineFlex style={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}>
            {
              !phase
                ? null
                : phase.data.map((item, i) =>
                  <ActivityCard
                    previewOnClick={setActivityPreviewModal}
                    setActivityId={setActivityId}
                    setSelectedPhaseIndex={() => setSelectedPhaseIndex(index)}
                    data={item}
                    key={i}
                  />)
            }
          </InlineFlex>
        </FlexWrapper>
      </Timeline.Item>
    </>
  )
}

export const ActivityCard = (props) => {
  const activityData = props.data
  return (
    <>
      {!activityData
        ? <Loader />
        : (
          <Card
            className='card'
            onClick={() => {
              props.previewOnClick(true)
              props.setActivityId(activityData.id)
              props.setSelectedPhaseIndex(props.index)
            }}
          >
            {!props.handleDelete
              ? null
              : <IconButton
                style={{ position: 'absolute', right: '0', background: 'transparent', zIndex: '5' }}
                icon={<DeleteIcon />}
                value={props.data.id}
                index={props.index}
                activityindex={props.activityindex}
                onClick={props.handleDelete}
              />}
            <TimelineImage className='image'>
              <img
                src={activityData.cover_image.thumbnail.url || defaultBackground}
                width='270px'
                height='290px'
              />
            </TimelineImage>
            <FlexWrapper className='description'>
              <NormalText className='duration'>{activityData.duration_min}-{activityData.duration_max}min</NormalText>
              <SmallTitle bolded className='title'>{!activityData.title.length ? null : activityData.title[0].text}</SmallTitle>
              <NormalText className='text'>
                {!activityData.description.length ? null : activityData.description[0].text}
              </NormalText>
            </FlexWrapper>
          </Card>
        )}
    </>
  )
}

export const SummaryBlock = (props) => {
  const EmptySummary = [
    { title: 'total min', amount: 0 },
    { title: 'phases', amount: 0 },
    { title: 'activities', amount: 0 }
  ]
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5% auto' }}>
      {!props.data.phases.length || !props.data.phases[0].data.length
        ? (EmptySummary.map((event, i) =>
          <SpanText key={i}><SpanText>{event.amount} </SpanText>{event.title}</SpanText>
        ))
        : <Summary {...props.data} />}
    </div>
  )
}

export const Summary = (props) => {
  const activityData = { phases: props.phases }
  const phases = !props.phases ? <Loader /> : props.phases.length
  const activitiesAmount = !props.phases
    ? <Loader />
    : props.phases.reduce((acc, el) => {
      acc += el.data.length
      return acc
    }, 0)

  const totalMaxDuration = moment.duration()
  const totalMinDuration = moment.duration()

  activityData?.phases.forEach(phase => {
    phase.data.forEach(activity => {
      if (activity.duration_max) totalMaxDuration.add(activity.duration_max, 'minutes')
      if (activity.duration_min) totalMinDuration.add(activity.duration_min, 'minutes')
    })
  })

  const totalMax = (totalMaxDuration.hours() ? (totalMaxDuration.hours() + 'h ') : '') +
                  (totalMaxDuration.minutes() ? (totalMaxDuration.minutes() + 'mins ') : '')

  const totalMin = (totalMinDuration.hours() ? (totalMinDuration.hours() + 'h ') : '') +
                  (totalMinDuration.minutes() ? (totalMinDuration.minutes() + 'mins') : '')

  const ActivitySummary = [
    { title: ' total', amount: isNaN(totalMinDuration) ? <Loader /> : `${totalMin} - ${totalMax}` },
    { title: ' phases', amount: phases },
    { title: ' activities', amount: activitiesAmount }]

  return (
    <InlineFlex style={{ width: '100%', margin: '1%' }}>
      {ActivitySummary.map((event, i) => {
        return (
          <SpanText large key={i}><PinkSpan>{event.amount}</PinkSpan>{event.title}</SpanText>
        )
      })}
    </InlineFlex>
  )
}

export const EmptyTimeline = () => {
  return (
    <>
      <Timeline.Item dot={<Icon className='customDot' icon='' />}>
        <P>Choose at least one goal to begin with</P>
        <Image src='./Images/Select goal pic.svg' alt='Select Goal' />
      </Timeline.Item>
      <Timeline.Item />
    </>
  )
}

export const PhasesConstructor = ({ phases = [], onClickAdd }) => {
  return (
    <>
      {
        phases.map((phase, index) =>
          <Timeline.Item key={index} dot={<Icon className='customDot' icon='' />}>
            <InlineFlex>
              <SmallTitle bolded>Phase {index + 1}: </SmallTitle>
              <SmallTitle>{phase.name}</SmallTitle>
            </InlineFlex>
            <FlexWrapper>
              <InlineFlex style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                {!phase ? <Loader /> : <ActivityCard {...phase} />}
                <AddEventActivity onClick={() => onClickAdd(index)} />
              </InlineFlex>
            </FlexWrapper>
          </Timeline.Item>)
      }
      <Timeline.Item dot={<Icon className='customDot' icon='' />}>
        <div> <Back> &#x2B; create new phase</Back> </div>
      </Timeline.Item>
    </>
  )
}
export const NewPhase = () => {
  return (
    <>
      <FormGroup>
        <ControlLabel>Phase 3</ControlLabel>
        <FormControl
          name='phase'
          placeholder='Enter Phase name'
        />
      </FormGroup>    </>
  )
}

export const AddEventActivity = ({ onClick }) =>
  <AddActivity onClick={onClick}>
    <FlexWrapper style={{ alignItems: 'center', marginTop: '35%' }}>
      <IconButton icon={<PaginateFilter />} />
      <Title style={{ color: `${colors.purpleMain}`, margin: '3% auto' }}>Add Activity</Title>
    </FlexWrapper>
  </AddActivity>

export const DeleteModal = (props) => {
  const message = {
    Event: `Are you sure you want to detele ${props.title} event?`,
    Phase: `Are you sure you want to detele ${props.title} phase with all activities in it?`
  }

  return (
    <Modal
      className='deleteModal'
      show={props.show}
      onHide={props.handleClose}
      style={{ width: '480px', margin: 'auto' }}
    >
      <Modal.Header>
        <IconButton style={{ display: 'flex', justifyContent: 'center', width: '100%', margin: 'auto', height: '100%', background: 'transparent' }} icon={<OpenBin stroke={colors.purpleMain} />} size='lg' />
      </Modal.Header>
      <Modal.Body>
        <SmallTitle style={{ justifyContent: 'center' }} centered>{message[props.msg]}</SmallTitle>
        <NormalText centered greyed>Once deleted you can’t get them back</NormalText>
      </Modal.Body>
      <Modal.Footer>
        <ButtonToolbar style={{ textAlign: 'center', padding: '5%' }}>
          <Button
            onClick={props.handleClose}
            style={styles.buttonStyle}
            className='btn-grey'
            appearance='ghost'>
            Cancel
          </Button>
          <Button
            onClick={props.onDelete()}
            value={props.id} color='red'
            className='btn-red'
            appearance='ghost'>
            Delete {props.msg}
          </Button>
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  )
}

export const EmptyPhaseModal = ({ show, handleClose, addPhase, onDelete }) => {
  return (
    <Modal
      className='deleteModal'
      show={show}
      onHide={handleClose}
      style={{ width: '480px', height: 'auto', margin: 'auto' }}
    >
      <Modal.Header>
        <IconButton style={{ display: 'flex', justifyContent: 'center', width: '100%', margin: 'auto', height: '100%', background: 'transparent' }} icon={<OpenBin stroke={colors.purpleMain} />} size='lg' />
      </Modal.Header>
      <Modal.Body>
        <SmallTitle style={{ justifyContent: 'center' }} centered>You do not have any phases in your event. Add a phase or discard event creation</SmallTitle>
        <NormalText centered greyed>Event should have at least one phase with an activity</NormalText>
      </Modal.Body>
      <Modal.Footer>
        <ButtonToolbar style={{ textAlign: 'center', padding: '5%' }}>
          <Button
            onClick={addPhase}
            style={{ borderColor: colors.grey, color: colors.grey }}
            className='btn-grey'
            appearance='ghost'>
            Add Phase
          </Button>
          <Button
            onClick={onDelete}
            color='red'
            className='btn-red'
            appearance='ghost'>
            Discard Event
          </Button>
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  )
}

export const PhaseSummary = (props) => {
  const data = props.data
  const duration = []
  data.map(item => {
    duration.push(item.duration_max || 0)
  })
  const activityDuration = !duration.length ? 0 : duration.reduce((prev, next) => prev + next, 0)
  let total = activityDuration
  if (total < 60) {
    total = `${Math.floor(total)} mins`
  } else if (total % 60 === 0) {
    total = `${Math.floor(total / 60)}h`
  } else {
    total = `${Math.floor(total / 60)}h ${Math.floor((total % 60))}min`
  }

  const activity = props.data.length
  return (
    <div style={{ width: 'max-content', padding: '7px 11px', margin: '0', fontSize: `${fonts.largeSize}`, alignSelf: 'flex-end' }}>
      <div style={{ color: colors.grey }}>{activity} activity | {total} </div>
    </div>
  )
}
